import styled from 'styled-components';

export const Header = styled.div`
  ${(p) => p.theme.typography.title}
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
